import React from "react";
import { connect } from "react-redux";
import AppRouter, { history } from '../routers/AppRouter';
//Actions
import { getClans } from '../actions/clans';
//Components
import Clan from './clan/Clan';
import ClanMembers from './ClanMembers';
import ClanMenu from './ClanMenu';
import ClanStatus from './ClanStatus';
import { Suscription } from './ClanStatus';
import Table from 'locki-dashboard-navigation/dist/table';
//Material-ui
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';

class Clans extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      clan: {},
      openClan: false
    };
  }
  componentDidMount(){
    const { clans } = this.props;
    //Prevents attching on callback more than once
    if (!clans.data.length) {
      this.props.getClans();
    }
  }
  handleAddClan = () => {
    this.setState((state) => {
      return {clan: {}};
    });
    this.toogleOpenClan();
  }
  handleEditClan = (clan) => {
    this.setState((state) => {
      return {clan};
    });
    this.toogleOpenClan();
  }
  toogleOpenClan = () => {
    this.setState((state) => {
      return {
        openClan: !state.openClan
      };
    });
  }
  render() {
    const { clans } = this.props;
    const data =  clans.data ? clans.data : [];
    const columns = [
      { id: 'address', align: 'left', padding: 'none', label: 'Domicilio' },
      { id: 'name', align: 'right', hideOnMobile: true, label: 'Familia' },
      { id: 'members', align: 'right', hideOnMobile: true, label: 'Miembros', component: ClanMembers },
      { id: 'status', align: 'right', label: 'Estatus', component: ClanStatus },
      { id: 'suscription', align: 'right', padding: 'none', label: '', component: Suscription},
      { id: 'id', align: 'right', padding: 'none', label: 'Opciones', component: ClanMenu, callback: (clan) => this.handleEditClan(clan) }
    ];
    const tooltip = (
      <Tooltip title="Añadir Familia">
        <Fab aria-label="Añadir Familia" color="secondary" size="medium">
          <AddIcon />
        </Fab>
      </Tooltip>
    );
    const table = (
      <Paper className="general-paper">
        <Table
          data={data}
          columns={columns}
          title="Familias"
          tooltip={tooltip}
          tooltipAction={this.handleAddClan}
        />
      </Paper>
    );
    return (
      <div>
        {this.state.openClan ? <Clan clan={this.state.clan} close={this.toogleOpenClan} /> : table }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  clans: state.clans
});

const mapDispatchToProps = (dispatch) => ({
  getClans: () => dispatch(getClans())
});

export default connect(mapStateToProps, mapDispatchToProps)(Clans);
